import * as Yup from 'yup';
import { GenderEnum, ImeiEnum } from '~/utils/enum';

const personValidation = (t: (key: string) => string) => ({
  edit: Yup.object().shape({
    full_name: Yup.string()
      .required(t('full_name.placeholder'))
      .matches(/^[^0-9]+$/, t('full_name.no_number')),
    cccd: Yup.string()
      .required(t('cccd.placeholder'))
      .matches(/^\d+$/, t('cccd.digits_only'))
      .length(12, t('cccd.max_length'))
      .matches(/^0/, t('cccd.start_zero')),
    simno: Yup.string()
      .required(t('simno.placeholder'))
      .matches(/^\d+$/, t('simno.digits_only'))
      .length(10, t('simno.max_length'))
      .matches(/^0/, t('simno.start_zero')),
    email: Yup.string().required(t('email.placeholder')).email(t('email.invalid')),
    birth_date: Yup.string().required(t('birth_date.placeholder')),
    place_of_origin: Yup.string().required(t('place_of_origin.placeholder')),
    current_address: Yup.string().required(t('current_address.placeholder')),
    gender: Yup.number()
      .oneOf([GenderEnum.FEMALE, GenderEnum.MALE], t('gender.invalid'))
      .required(t('gender.placeholder')),
    province_id: Yup.string().required(t('select_province_id')),
    ward_id: Yup.string().required(t('select_ward_id')),
    imei: Yup.string().when('assign_type', {
      is: ImeiEnum.ASSIGNED,
      then: (schema) => schema.required(t('assignStatus.placeholder')),
      otherwise: (schema) => schema.notRequired().nullable(),
    }),
  }),
});

export default personValidation;
